import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, IconButton, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CompanyHeader = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ position: 'relative' }}>
      <Typography
        sx={{
          fontSize: '2.5rem',
          fontWeight: '700',
          color: '#002B38',
          textAlign: 'center',
          marginBottom: '1.25rem',
        }}
      >
        ประวัติการใช้งาน
      </Typography>

      <IconButton
        onClick={() => navigate('/admin')}
        sx={{
          width: {
            xs: 'auto',
            sm: 120,
          },
          height: 40,
          fontSize: '1.25rem',
          color: '#004B61',
          marginBottom: '1rem',
          position: 'absolute',
          top: '50%',
          left: '0',
          transform: 'translateY(-50%)',
          backgroundColor: '#fafafa',
          borderRadius: '6px',
          zIndex: '10',

          '&:hover': {
            opacity: '.85',
            backgroundColor: '#fafafa',
          },
        }}
      >
        <ArrowBackIosIcon
          sx={{
            fontSize: '1rem',
            color: '#004B61',
          }}
        />
        <Box component={'span'} sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
          ย้อนกลับ
        </Box>
      </IconButton>
    </Box>
  );
};
export default CompanyHeader;
